export const localStorageChecker = async (): Promise<void> => {
    const storedData = window.localStorage.getItem("settings");
    if (storedData) {
        const settings = JSON.parse(storedData);

        if (settings?.version === import.meta.env.VITE_SETTINGS_VERSION) {
            return;
        }
    }
    window.localStorage.removeItem("settings");
    return;
};
